var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrahp2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_3509)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_3509)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_176_3509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.34 99.9662H25.2421C22.3473 99.9662 20 97.6465 20 94.7844V16.9064C20 14.0449 22.3467 11.7246 25.2421 11.7246H212.34C215.235 11.7246 217.582 14.0443 217.582 16.9064V94.7844C217.582 97.6465 215.235 99.9662 212.34 99.9662Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.804 34.2983H28.5545C28.4538 34.2983 28.3721 34.1604 28.3721 33.9904C28.3721 33.8205 28.4538 33.6826 28.5545 33.6826H130.804C130.904 33.6826 130.986 33.8205 130.986 33.9904C130.986 34.1604 130.904 34.2983 130.804 34.2983Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.804 47.8168H28.5545C28.4538 47.8168 28.3721 47.6789 28.3721 47.509C28.3721 47.3391 28.4538 47.2012 28.5545 47.2012H130.804C130.904 47.2012 130.986 47.3391 130.986 47.509C130.986 47.6789 130.904 47.8168 130.804 47.8168Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.804 61.3344H28.5545C28.4538 61.3344 28.3721 61.1965 28.3721 61.0266C28.3721 60.8567 28.4538 60.7188 28.5545 60.7188H130.804C130.904 60.7188 130.986 60.8567 130.986 61.0266C130.986 61.1965 130.904 61.3344 130.804 61.3344Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.804 74.8529H28.5545C28.4538 74.8529 28.3721 74.715 28.3721 74.5451C28.3721 74.3752 28.4538 74.2373 28.5545 74.2373H130.804C130.904 74.2373 130.986 74.3752 130.986 74.5451C130.986 74.715 130.904 74.8529 130.804 74.8529Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.804 88.3715H28.5545C28.4538 88.3715 28.3721 88.2336 28.3721 88.0637C28.3721 87.8938 28.4538 87.7559 28.5545 87.7559H130.804C130.904 87.7559 130.986 87.8938 130.986 88.0637C130.986 88.2336 130.904 88.3715 130.804 88.3715Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4775 44.4531H31.8174V88.0629H38.4775V44.4531Z",
    fill: "#CC197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2239 51.4297H48.5637V88.0619H55.2239V51.4297Z",
    fill: "#4925AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.724 65.1787H40.0638V88.0619H46.724V65.1787Z",
    fill: "#D68D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7273 63.999H68.0665V88.0624H74.7273V63.999Z",
    fill: "#CC197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4731 76.5488H84.8129V88.0624H91.4731V76.5488Z",
    fill: "#4925AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9731 50.4639H76.313V88.0626H82.9731V50.4639Z",
    fill: "#D68D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.977 76.2363H104.316V88.0627H110.977V76.2363Z",
    fill: "#CC197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.723 51.3604H121.063V88.0633H127.723V51.3604Z",
    fill: "#4925AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.223 37.8438H112.563V88.063H119.223V37.8438Z",
    fill: "#D68D2F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_3509",
    x: 0,
    y: 0,
    width: 160,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_3509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_3509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_176_3509",
    x: -18,
    y: -8.27539,
    width: 274,
    height: 128.275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_3509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_3509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_3509"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 120,
    height: 80,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrahp2);
export default __webpack_public_path__ + "static/media/grahp2.c3909739ef40b09a54943f162ac3381c.svg";
export { ForwardRef as ReactComponent };